import React, { Fragment } from 'react';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import CardFooter from './CardFooter';
import Table from './Table';

const QUERY = gql`
    query ($operatorId: String!) {
        portalTerminals(operatorId: $operatorId) {
            id,
            activationKey,
            name,
            logicalNumber,
            establishment {
                title    
            },
            pinpad {
                serialNumber,
                model {
                    brand,
                    model
                }
            },
            isActive,
            createdAt
        }
    }
`;

const Card = ({ operatorId }) => (
    <div className="card shadow">
        <div className="card-header border-0">
            <h3 className="mb-0">Terminais</h3>
        </div>
        <Query query={QUERY} variables={{ operatorId }}>
            {({ loading, error, data }) => {
                if (loading) return 'Loading...';
                if (error) {
                    return (
                        <div className="rounded-0 alert alert-warning m-0">
                            Não foi possível carregar a lista de terminais.
                        </div>
                    );
                }
                const { portalTerminals } = data;

                return (
                    <Fragment>
                        <Table terminals={portalTerminals} />
                        <CardFooter />
                    </Fragment>
                );
            }}
        </Query>
    </div>
);

const mapDispatchToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapDispatchToProps)(Card);


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Card.js